import { Grid } from '@mui/material';
import { HSpacer, RoutalDialog } from '@nx-smartmonkey/ui';
import React from 'react';

import Button from '../react-components/Button';
import Text from '../react-components/Text';

type ConfirmDialogProps = {
  title: string | React.ReactElement;
  description: string | React.ReactElement;
  open: boolean;
  cancelIntlId?: string;
  confirmIntlId?: string;
  onCloseDialog: (...args: any[]) => any;
  onConfirm: (...args: any[]) => any;
};

const ConfirmDialog = ({
  open,
  title,
  description,
  cancelIntlId,
  confirmIntlId,
  onCloseDialog,
  onConfirm,
}: ConfirmDialogProps) => (
  <RoutalDialog
    open={open}
    onCloseDialog={onCloseDialog}
    titleContent={title}
    footerContent={
      <Grid container justifyContent="flex-end">
        <Button intlId={cancelIntlId ?? `cancel`} onClick={() => onCloseDialog()} variant="flat" />
        <HSpacer small />
        <Button
          intlId={confirmIntlId ?? `confirm`}
          variant="default"
          styleType="primary"
          autoFocus
          onClick={() => {
            onConfirm();
          }}
        />
      </Grid>
    }
  >
    <Text>{description}</Text>
  </RoutalDialog>
);

export default ConfirmDialog;
